import script from "./MainPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainPanel.vue?vue&type=script&lang=ts&setup=true"

import "./MainPanel.vue?vue&type=style&index=0&id=7a0a271c&lang=scss&scoped=true"

import exportComponent from "/home/deploy/www/data/workspace/ads_tencn-prod/ads/src/grow-team-assist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a0a271c"]])

export default __exports__